<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-align-justify"></i> Surveys
                  <button type="button" class="btn btn-outline-primary pull-right" @click="addSurvey"><i class="fa fa-plus"></i>&nbsp; Add Survey</button>
              </div>
              <div class="card-block">
                <table class="table table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Revision</th>
                      <th>Last Updated</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Created By</th>
                      <th>Is Deleted?</th>
                      <th>Test Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in surveyList">
                      <tr>
                        <td>{{item.surveyName}}</td>
                        <td>{{item.revisionNumber}}</td>
                        <td>{{formatDate(item.idt)}}</td>
                        <td>{{item.dateEffective}}</td>
                        <td>{{item.dateTerminated}}</td>
                        <td>{{item.createdBy}}</td>
                        <td>{{item.isDeleted}}</td>
                        <td><router-link :to="{name: 'Survey', params: { id:item.surveyID}}" class="link" exact>Test</router-link></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <nav>
                  <ul class="pagination">
                    <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                    <li class="page-item active">
                      <a class="page-link" href="#">1</a>
                    </li>
                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                    <li class="page-item"><a class="page-link" href="#">4</a></li>
                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div><!--/.col-->
        </b-row><!--/.row-->
      </div><!--animated-fadein -->
        <b-modal title="Add Survey" v-model="myModal" @ok="uploadSurvey" effect="fade/zoom" ok-text="Add Survey" cancel-text="Cancel">
        <div slot="modal-header" class="modal-header">
          <h5 class="modal-title"><i class="fa fa-plus"></i> Add Survey</h5>
        </div>
        <b-col sm="12">
          <b-card>
            <div class="card-block">
              <b-form action="" method="post" enctype="multipart/form-data" class="form-horizontal">
                <b-form-group label="Survey Name" label-for="surveyName">
                  <b-form-input  type="text" class="form-control" id="surveyName" placeholder="Survey Name" v-model="uploadFormData.surveyName"/>
                </b-form-group>
                <b-form-group label="Excel File" label-for="uploadfile">
                  <input type="file" class="form-control" id="uploadfile" ref="file" v-on:change="handleFileUpload($event.target.name, $event.target.files)"/>
                </b-form-group>
                <div class="row">
                </div><!--/.row-->
              </b-form>
            </div>
          </b-card>
        </b-col><!--/.col-->
      </b-modal>
    </div><!--wrapper-->
</template>

<script>
import { tokenMixin } from '@/mixins/tokenMixin'
//import modal from 'bootstrap-vue'

export default {
  name: 'AdminSurveyManager',
  mixins: [tokenMixin],
  components: {
    //modal
  },
  data () {
    return {
      surveyList: [],
      myModal: false,
      element: '',
      formData: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: ''
      },
      uploadFormData: {
        surveyName: '',
        uploadFile: []

      }
    }
  },
  methods: {
    handleFileUpload (name, file) {
      this.uploadFormData.uploadFile = file;
    },
    addSurvey (e) {
      e.preventDefault();
      this.myModal = true;
    },
    uploadSurvey () {
      if (this.uploadFormData.uploadFile)
      {
        this.myModal = false;
        var self = this;
        var config = {
          headers: {'Authorization': 'bearer ' + this.$localStorage.get('token')}
        };
        const fd = new FormData();
        fd.append('SurveyName', this.uploadFormData.surveyName)
        fd.append('files', this.uploadFormData.uploadFile[0], this.uploadFormData.uploadFile[0].name)
        this.axios.post(process.env.VUE_APP_API_BASE + 'admin/surveymanager/upload', fd, config)
          .then(function (response) {
            self.loadSurveyList();
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    formatDate (dateIn) {
      if (dateIn === null || dateIn === '0001-01-01T00:00:00')
      {
        return ''
      }
      else {
        var dateOut = new Date(dateIn);
        return dateOut.toLocaleDateString();
      }
    },
    deleteNews (id) {
      return true
    },
    unDeleteNews (id) {
      return true
    },
    loadSurveyList () {
      console.log('load survey')
      if (this.checkForToken())
      {
        this.axios.get(process.env.VUE_APP_API_BASE + 'admin/surveymanager/GetAllSurveys', this.buildTokenHeader()).then(response => {
          return response
        })
        .then(res => {
          if (res.status === 200)
          {
            this.surveyList = res.data;
            //console.log(res.data);
          }
        })
        .catch(error => {
          console.log(error.response)
        });
      }
    }
  },
  mounted: function () {
    this.loadSurveyList();
  }
}
</script>
